var path = 'areas/projects/actions/wildfly/Octopus.WildFlyDeploy_summary.html';
var html = "<p> Deploy package <strong>{{ packageId }}</strong> from <strong ng-show=feedName>{{ feedName }}</strong><em ng-hide=feedName>{{ feedId }}</em> <span ng-show=isSingleStep>to Wildfly/Red Hat JBoss EAP instances in roles: <tag-list tags='properties[\"Octopus.Action.TargetRoles\"]'></tag-list></span> </p> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/wildfly/Octopus.WildFlyDeploy_summary.html
// module id = 7296607269810791
// module chunks = 1